export default __webpack_public_path__ + "images/a1addb9337f10990d54d87bec63f9a83-amex@2x.png";